import { documentNumberTranslations } from './document-number-i18n';
import { duplicationTranslations } from './duplication-i18n';
import { partnerMapTranslations } from './partner-map-i18n';
import { actionNeedTranslations } from './action-needs-i18n';
import { listViewTranslations } from './list-view-i18n';
import { pdfFieldCheckTranslations } from './pdf-field-check-i18n';
import { batchSelectionTranslations } from './batch-selection-i18n';
import { documentProgressTranslations } from './document-progress-i18n';
import { stockAdjustmentTranslations } from './stock-adjustment-i18n';
import { documentLockTranslations } from './document-lock-i18n';
import { portalRecoveryTranslations } from './portal-recovery-i18n';

import { priceGroupTranslations } from './price-group-i18n';
import { shippingTranslations } from '@erp/shared';
import { headerTranslations } from './header-i18n';
import { documentEntryTranslations } from './document-entry-i18n';
import { documentWorkspaceTranslations } from './document-workspace-i18n';
import { subdivisionTranslations } from './subdivision-i18n';
import { contactBriefingTranslations } from './contact-briefing-i18n';
import { internationalTranslations } from './international-i18n';
import { deliveryPlanningTranslations } from '@erp/shared';
import { introductionTranslations } from './introduction-i18n';
import { adminEn } from './admin-en';
import { analyticsEn } from './analytics-en';
import { dashboardEn } from './dashboard-i18n';
import { dmsEn } from './dms-en';
import { partnersEn } from './partners-en';
import { pdfDesignerEn } from './pdf-designer-en';
import { procurementEn } from './procurement-en';
import { questionnairesEn } from './questionnaires-en';
import { settingsHubEn } from './settings-hub-en';
import { telephonyEn } from './telephony-en';
import { whatsAppEn } from './whatsapp-en';
import { helpEn } from './help-en';
import { feedbackEn } from './feedback-en';
import { productSpecificationsEn } from './product-specifications-en';
import { plmEn } from './plm-en';
import { manufacturingEn } from './manufacturing-en';
import { traceabilityEn } from './traceability-en';
import { mrpEn } from './mrp-en';
import { labelsEn } from './labels-en';
import { changeControlEn } from './change-control-en';
import { productDevelopmentDashboardEn } from './product-development-dashboard-en';
import { searchEn } from './search-i18n';
import { vatValidationEn } from './vat-validation-i18n';
import { navigationEn } from './navigation-i18n';
import { dunningEn } from './dunning-i18n';
import { portalEn } from './portal-i18n';
import { productNewsEn } from './product-news-i18n';
import { newsletterEn } from './newsletter-i18n';
import { setupEn } from './setup-i18n';
import { importCenterEn } from './import-center-i18n';
import { bankingEn } from './banking-i18n';
import { translationGlossaryEn } from './translation-glossary-i18n';
import { salesAssistantEn } from './sales-assistant-i18n';
import { customerHeaderEn } from './customer-header-i18n';
import { featureAdminEn } from './feature-admin-i18n';

export const en = {
  translation: {
    documentNumber: documentNumberTranslations.en,
    duplication: duplicationTranslations.en,
    partnerMap: partnerMapTranslations.en,
    actionNeeds: actionNeedTranslations.en,
    listViews: listViewTranslations.en,
    pdfFieldCheck: pdfFieldCheckTranslations.en,
    stockAdjustment: stockAdjustmentTranslations.en,
    batchSelection: batchSelectionTranslations.en,
    documentProgress: documentProgressTranslations.en,
    documentLock: documentLockTranslations.en,
    portalRecovery: portalRecoveryTranslations.en,
    shipping: shippingTranslations.en,
    priceGroups: priceGroupTranslations.en,
    header: headerTranslations.en,
    documentEntry: documentEntryTranslations.en,
    documentWorkspace: documentWorkspaceTranslations.en,
    ...contactBriefingTranslations.en,
    international: internationalTranslations.en,
    subdivision: subdivisionTranslations.en,
    deliveryPlanning: deliveryPlanningTranslations.en,
    introduction: introductionTranslations.en,
    admin: { ...adminEn, dataHub: importCenterEn, features: featureAdminEn },
    analytics: analyticsEn,
    dms: dmsEn,
    portal: portalEn,
    productNews: productNewsEn,
    newsletter: newsletterEn,
    setup: setupEn,
    partners: partnersEn,
    pdfDesigner: pdfDesignerEn,
    procurement: procurementEn,
    questionnaires: questionnairesEn,
    settingsHub: settingsHubEn,
    telephony: telephonyEn,
    whatsapp: whatsAppEn,
    help: helpEn,
    feedback: feedbackEn,
    productSpecifications: productSpecificationsEn,
    plm: plmEn,
    manufacturing: manufacturingEn,
    traceability: traceabilityEn,
    mrp: mrpEn,
    labels: labelsEn,
    changeControl: changeControlEn,
    productDevelopmentDashboard: productDevelopmentDashboardEn,
    search: searchEn,
    vatValidation: vatValidationEn,
    dunning: dunningEn,
    banking: bankingEn,
    translationGlossary: translationGlossaryEn,
    paymentTerms: {
      netDays_one: '{{count}} net day',
      netDays_other: '{{count}} net days',
      discountPreview: '{{due}}, {{percent}}% discount within {{days}} days',
      customLegacy: 'Custom legacy terms',
      search: 'Search payment terms…',
      noResults: 'No matching payment terms found.',
      loadError: 'Payment terms could not be loaded.',
      warningCustom: 'These legacy values are not linked to a configured rule.',
      warningInconsistent: 'The legacy values conflict. Please select valid payment terms.',
      advanced: 'Custom payment values',
      customAgreement: 'Individual agreement',
      selectionHint:
        'The payment deadline and cash discount are taken automatically from the selected payment terms.',
      customHint:
        'These individual values apply instead of catalogue terms. Selecting terms above replaces them.',
      customize: 'Set individual terms',
      inconsistentValues:
        'The discount period, cash discount and payment deadline conflict. Check the values or select payment terms.',
      savedValues: 'Stored terms · {{due}} · {{percent}}% cash discount within {{days}} days',
    },
    addressResolution: {
      automatic: 'Determined automatically',
      adoptRegion: 'Use suggested region {{region}}',
      importPlan: 'Region assignment in the confirmed dry run (manual values are preserved)',
      status: {
        RESOLVED: 'Region determined unambiguously.',
        INCOMPLETE: 'Enter a complete five-digit postal code.',
        UNSUPPORTED: 'Automatic region assignment is not available for this country.',
        NO_MATCH: 'No matching commune found. Check the address or enter the region manually.',
        CONFLICT: 'The city and postal code do not match. Correct the address or choose a commune.',
        AMBIGUOUS: 'Matches belong to different regions. Choose the correct commune.',
        MISSING_REGION:
          'The administrative data does not contain a complete region. Enter it manually.',
        UNAVAILABLE: 'Region lookup is currently unavailable. You can still save manually.',
      },
      backfill: {
        title: 'Complete empty regions in existing French addresses',
        hint: 'Preview up to 50 addresses at a time. Select and confirm unambiguous additions. Changed records and populated regions are skipped. The preview expires after 30 minutes.',
        partners: 'Check main addresses',
        addresses: 'Check additional addresses',
        next: 'Check next group',
        empty: 'No further French addresses with an empty region found.',
        select: 'Select {{label}} for completion',
        apply: 'Confirm {{count}} selected additions',
        result: '{{updated}} completed; {{skipped}} changed or already completed.',
        error: 'Processing failed. Create a new preview and check again.',
      },
      loading: 'Looking up city and region…',
      errorFallback: 'Location lookup is unavailable. Please enter the details manually.',
      noResults: 'No matching location found. Please enter it manually.',
      useSuggestion: 'Use {{value}}',
      choose: 'Choose a city',
      chooseCount: '{{count}} cities found — please choose',
      source: 'Source: {{source}}',
      help: 'Help with location lookup',
    },
    salesAssistant: salesAssistantEn,
    customerHeader: customerHeaderEn,
    app: {
      name: 'ERP',
      tagline: 'Modular Web ERP',
    },
    nav: {
      ...navigationEn,
      label: 'Main navigation',
      openMenu: 'Open menu',
      expandGroup: 'Expand {{name}}',
      collapseGroup: 'Collapse {{name}}',
      dashboard: 'Dashboard',
      partners: 'Business partners',
      partnerCustomers: 'Customers',
      partnerProspects: 'Prospects / leads',
      partnerSuppliers: 'Suppliers',
      partnerAll: 'All contacts',
      products: 'Products',
      productDevelopment: 'Product development',
      productDevelopmentOverview: 'Overview',
      recipes: 'Recipes and BOMs',
      batchScaling: 'Batch scaling',
      declarations: 'Declarations',
      declarationCatalog: 'Declaration master data',
      analysisProfiles: 'Analysis profiles',
      analysisParameters: 'Analysis parameters',
      labels: 'Labels',
      changeControl: 'Change control',
      documents: 'Documents',
      dms: 'Document archive',
      procurement: 'Procurement',
      manufacturing: 'Manufacturing',
      productionOrders: 'Production orders',
      traceability: 'Lot traceability',
      mrp: 'Material requirements planning',
      purchaseOrders: 'Purchase orders',
      goodsReceipts: 'Goods receipts',
      vendorInvoices: 'Vendor invoices',
      analytics: 'Analytics',
      analyticsOverview: 'General analytics',
      employeePerformance: 'Employee performance',
      datev: 'DATEV export',
      intrastat: 'Intrastat',
      settings: 'Settings',
      profile: 'My profile',
      security: 'Security',
      notifications: 'Notifications',
      company: 'Company',
      pdfDesigner: 'PDF templates',
      users: 'Users',
      roles: 'Roles & permissions',
      securityLog: 'Security log',
      admin: 'Administration',
      whatsapp: 'WhatsApp',
      whatsappConfig: 'WhatsApp configuration',
      field: 'Field service',
      questionnaireTemplates: 'Questionnaires',
      questionnaireResults: 'Questionnaire results',
    },
    console: {
      label: 'Administration',
      breadcrumb: 'Breadcrumb',
      openMenu: 'Open administration menu',
      backToApp: 'Back to main view',
      groups: {
        overview: 'System & overview',
        access: 'Access & security',
        configuration: 'Configuration',
        communication: 'Communication',
      },
      items: {
        accounting: 'DATEV chart of accounts',
        questionnaireTemplates: 'Questionnaire templates',
        questionnaireResults: 'Questionnaire results',
        questionnaireSettings: 'Questionnaire settings',
      },
    },
    theme: {
      label: 'Appearance',
      light: 'Light',
      dark: 'Dark',
      system: 'System',
    },
    language: {
      label: 'Language',
      search: 'Search languages',
      noResults: 'No language found.',
      saveError: 'The language could not be saved.',
      tr: 'Turkish',
      fr: 'French',
      es: 'Spanish',
      de: 'German',
      en: 'English',
    },
    dashboard: {
      title: 'Dashboard',
      ...dashboardEn,
    },
    errorPage: {
      title: 'Unexpected error',
      description: 'This view could not be loaded.',
      reload: 'Reload page',
    },
    systemStatus: {
      title: 'System status',
      description: 'Live readiness check of the API.',
      loading: 'Loading status …',
      error: 'The system status could not be loaded.',
      retry: 'Try again',
      api: 'API',
      database: 'Database',
      version: 'Version',
      uptime: 'Uptime',
      state: {
        ok: 'Operational',
        degraded: 'Degraded',
        up: 'Connected',
        down: 'Disconnected',
      },
      uptimeValue: '{{minutes}} min',
    },
    common: {
      loading: 'Loading …',
      create: 'Create',
      saving: 'Saving…',
      save: 'Save',
      confirm: 'Confirm',
      select: 'Please select',
      error: 'An unexpected error occurred.',
      cancel: 'Cancel',
      back: 'Back',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      retry: 'Retry',
      previous: 'Previous',
      next: 'Next',
      none: 'None',
      pleaseSelect: 'Please select',
      pagination: 'Pagination',
      paginationInfo: 'Page {{page}} of {{totalPages}} · {{total}} records',
      copy: 'Copy',
      copied: 'Copied',
      actions: 'Actions',
      showDetails: 'Show details',
      hideDetails: 'Hide details',
    },
    validation: {
      required: 'Required',
      email: 'Please provide a valid email address.',
    },
    errors: {
      requestFailed: 'The request failed',
      unexpectedTitle: 'Unexpected error',
      unexpectedMessage: 'An unexpected error occurred.',
      copyHint: '(click to copy)',
      copyId: 'Copy ID',
      copied: 'Error ID {{id}} copied.',
    },
    documentPricing: {
      overrideRequired: 'This role cannot change prices or financial conditions.',
    },
    permissions: {
      customerPricingReadOnly:
        'Price groups, discounts and cash discount terms are read-only for this role.',
      deniedTitle: 'No access',
      deniedDescription: 'This view requires the permission {{permission}}.',
    },
    auth: {
      title: 'Sign in',
      subtitle: 'Sign in with your credentials.',
      email: 'Email',
      password: 'Password',
      tenantSlug: 'Tenant',
      tenantSlugHint: 'Short name of the tenant, e.g. acme.',
      submit: 'Sign in',
      logout: 'Sign out',
      checking: 'Checking session …',
      invalidCredentials: 'Email or password is incorrect.',
      accountLocked: 'The account is temporarily locked. Please try again later.',
      tenantRequired: 'This email exists in several tenants. Please provide the tenant.',
      twoFactor: {
        title: 'Two-factor verification',
        description: 'Enter the six digit code from your authenticator app.',
        emailDescription: 'Enter the six-digit code sent to {{email}}.',
        useMethod: { TOTP: 'Use authenticator app', EMAIL: 'Use email code' },
        resend: 'Resend code',
        resendIn: 'Resend in {{seconds}} s',
        backupDescription: 'Enter one of your backup codes.',
        code: 'Verification code',
        backupCode: 'Backup code',
        submit: 'Verify',
        invalid: 'The code is invalid or expired.',
        useBackupCode: 'Use a backup code',
        useAuthenticator: 'Use the authenticator app',
      },
    },
    customFields: {
      createTitle: 'Create custom field',
      editTitle: 'Edit custom field',
      dialogDescription:
        'Custom fields extend customer data without code changes. Key and field type are fixed after creation.',
      key: 'Key',
      keyHint: 'Technical name, e.g. customerGroup.',
      type: 'Field type',
      label: 'Label',
      labelEn: 'Label (English)',
      group: 'Group',
      sortOrder: 'Sort order',
      required: 'Required',
      showInList: 'Show in list',
      filterable: 'Filterable',
      marketingSegmentationAllowed: 'Approved for newsletter segmentation',
      options: 'Options',
      addOption: 'Add option',
      removeOption: 'Remove option',
      noOptions: 'No options defined yet.',
      optionValue: 'Value',
      optionLabel: 'Label',
      created: 'Custom field created.',
      updated: 'Custom field updated.',
      archived: 'Custom field archived.',
      archive: 'Archive',
      archiveTitle: 'Archive custom field',
      archiveDescription: 'The field "{{name}}" will be hidden. Existing values are kept.',
      saveError: 'The custom field could not be saved.',
      loadError: 'The custom fields could not be loaded.',
      filters: {
        action: 'Custom fields',
        title: 'Filter by custom fields',
        description: 'Text fields use contains matching; other fields use exact values.',
        reset: 'Reset',
        clearField: 'Clear filter for {{field}}',
      },
      weeklySchedule: {
        empty: 'No time windows recorded.',
        hint: 'Choose weekdays and local times. You can add multiple time windows. The end time must follow the start time on the same day.',
        invalid: 'Enter at least one weekday and valid start and end times.',
        required: 'At least one complete time window is required.',
      },
      types: {
        WEEKLY_SCHEDULE: 'Weekdays & times',
        TEXT: 'Text',
        TEXTAREA: 'Multiline text',
        NUMBER: 'Number',
        DATE: 'Date',
        CHECKBOX: 'Checkbox',
        SELECT: 'Select',
        MULTI_SELECT: 'Multi select',
      },
    },
    customers: {
      title: 'Customers',
      subtitle: 'Master data, terms and contact history of all customers.',
      searchPlaceholder: 'Search name, number, city, VAT ID …',
      searchLabel: 'Search customers',
      columnsMenu: 'Columns',
      createTitle: 'New customer',
      editTitle: 'Edit customer',
      formDescription: 'Required fields are marked. The customer number is assigned automatically.',
      created: 'Customer created.',
      updated: 'Customer saved.',
      saveError: 'The customer could not be saved.',
      actions: {
        create: 'New customer',
        export: 'Export',
        logCall: 'Log call',
        createQuote: 'Create quote',
        backToList: 'Back to list',
      },
      tabs: {
        master: 'Master data & addresses',
        customFields: 'Custom fields',
        history: 'History',
        documents: 'Documents',
        whatsapp: 'WhatsApp',
      },
      sections: {
        masterData: 'Master data',
        address: 'Address',
        tax: 'Tax & identification',
        conditions: 'Payment terms',
        customFields: 'Custom fields',
      },
      detail: {
        since: 'Created on {{date}}',
      },
      values: {
        days_one: '{{count}} day',
        days_other: '{{count}} days',
      },
      columns: {
        customerNumber: 'Number',
        displayName: 'Name',
        status: 'Status',
        industry: 'Industry',
        email: 'Email',
        phone: 'Phone',
        city: 'City',
        countryCode: 'Country',
        vatId: 'VAT ID',
        ownerName: 'Owner',
        tags: 'Tags',
      },
      fields: {
        type: 'Customer type',
        status: 'Status',
        customerNumber: 'Customer number',
        customerNumberHint: 'Leave empty for automatic assignment.',
        industry: 'Industry',
        companyName: 'Company name',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        phone: 'Phone',
        website: 'Website',
        street: 'Street',
        houseNumber: 'House number',
        addressLine2: 'Address line 2',
        postalCode: 'Postal code',
        city: 'City',
        region: 'Region',
        countryCode: 'Country',
        vatId: 'VAT ID',
        vatIdHint: 'The format is validated, e.g. DE123456789.',
        vatIdStatus: 'VAT ID status',
        taxNumber: 'Tax number',
        taxCategory: 'Tax category',
        datevDebtorAccount: 'DATEV debtor account',
        gln: 'GLN',
        eoriNumber: 'EORI number',
        currency: 'Currency',
        documentLanguage: 'Document language',
        paymentTermsDays: 'Payment terms (days)',
        defaultDiscountPct: 'Discount',
        cashDiscountPct: 'Cash discount',
        cashDiscountDays: 'Cash discount period (days)',
        deliveryTerms: 'Delivery terms',
        creditLimit: 'Credit limit',
        priceGroup: 'Price group',
        minRemainingShelfLifeDays: 'Minimum remaining shelf life (days)',
        deliveryBlock: 'Delivery block',
        dunningBlock: 'Dunning block',
        ownerName: 'Owner',
        tags: 'Tags',
        tagsHint: 'Separate multiple values with commas.',
      },
      types: {
        COMPANY: 'Company',
        PERSON: 'Private person',
      },
      statuses: {
        ACTIVE: 'Active',
        PROSPECT: 'Prospect',
        BLOCKED: 'Blocked',
        INACTIVE: 'Inactive',
      },
      vatIdStatuses: {
        UNCHECKED: 'Unchecked',
        VALID: 'Valid',
        INVALID: 'Invalid',
        NOT_CHECKABLE: 'Not checkable',
        SERVICE_UNAVAILABLE: 'Service unavailable',
      },
      taxCategories: {
        DOMESTIC: 'Domestic',
        EU_B2B: 'EU B2B',
        EU_B2C: 'EU B2C',
        THIRD_COUNTRY: 'Third country',
        REVERSE_CHARGE_DOMESTIC: 'Reverse charge (domestic)',
        TAX_EXEMPT: 'Tax exempt',
      },
      industries: {
        RETAIL: 'Retail',
        WHOLESALE: 'Wholesale',
        MANUFACTURING: 'Manufacturing',
        GASTRONOMY: 'Gastronomy',
        LOGISTICS: 'Logistics',
        HEALTHCARE: 'Healthcare',
        PUBLIC_SECTOR: 'Public sector',
        CONSTRUCTION: 'Construction',
        AGRICULTURE: 'Agriculture',
        SERVICES: 'Services',
        OTHER: 'Other',
      },
      documentTypes: {
        QUOTE: 'Quote',
        ORDER: 'Order',
        DELIVERY_NOTE: 'Delivery note',
        INVOICE: 'Invoice',
        CREDIT_NOTE: 'Credit note',
        CANCELLATION: 'Cancellation',
      },
      documentStatuses: {
        DRAFT: 'Draft',
        OPEN: 'Open',
        CONFIRMED: 'Confirmed',
        PARTIALLY_DELIVERED: 'Partially delivered',
        DELIVERED: 'Delivered',
        POSTED: 'Posted',
        PAID: 'Paid',
        CANCELLED: 'Cancelled',
      },
      filters: {
        status: 'Status',
        industry: 'Industry',
        tags: 'Tags',
        vatIdStatus: 'VAT ID',
        reset: 'Reset filters',
      },
      states: {
        empty: 'No customers yet.',
        emptyFiltered: 'No customers match the current selection.',
        error: 'The customer list could not be loaded.',
        detailError: 'The customer could not be loaded.',
      },
      export: {
        csv: 'Download CSV',
        xlsx: 'Download Excel',
        success: 'Export created.',
        error: 'The export failed.',
      },
      delete: {
        title: 'Delete customer',
        description: 'The customer "{{name}}" will be deactivated and hidden.',
        success: 'Customer deleted.',
        error: 'The customer could not be deleted.',
      },
      addresses: {
        title: 'Additional addresses',
        add: 'Address',
        createTitle: 'Add address',
        editTitle: 'Edit address',
        description: 'Shipping and billing addresses differing from the main address.',
        type: 'Address type',
        label: 'Label',
        recipient: 'Recipient',
        isDefault: 'Default',
        contact: {
          title: 'Contact for this address',
          hint: 'Optional details for this address only. No general contact is created.',
          name: 'Name',
          position: 'Role / position',
          phone: 'Telephone',
          mobile: 'Mobile',
          email: 'Email',
          invalidEmail: 'Please enter a valid email address.',
        },
        deliveryTermsOverride: 'Override delivery terms',
        individualDeliveryTerms: 'Individual delivery terms',
        inheritedDeliveryTerms: 'Customer default: {{value}}',
        deliveryTermsHint:
          'Without an override, the delivery terms from the customer master data are used automatically.',
        confirmRemoveDeliveryTerms:
          'Changing the address type removes its individual delivery terms. Continue?',
        empty: 'No additional addresses.',
        created: 'Address saved.',
        updated: 'Address updated.',
        deleted: 'Address deleted.',
        delete: 'Delete address',
        deleteTitle: 'Delete address',
        deleteDescription: 'The address will be removed from the customer record.',
        error: 'The address could not be saved.',
        loadError: 'The addresses could not be loaded.',
        types: {
          BILLING: 'Billing address',
          SHIPPING: 'Shipping address',
          OTHER: 'Other',
        },
      },
      contacts: {
        title: 'Contacts',
        add: 'Contact',
        createTitle: 'Add contact',
        editTitle: 'Edit contact',
        description: 'Contact persons for quotes, orders and calls.',
        salutation: 'Salutation',
        title_label: 'Title',
        position: 'Position',
        department: 'Department',
        mobile: 'Mobile',
        isPrimary: 'Primary contact',
        responsibilities: 'Responsibilities',
        responsibilitiesHint: 'Separate multiple responsibilities with commas.',
        optOutMarketing: 'Exclude from marketing communications',
        empty: 'No contacts yet.',
        created: 'Contact saved.',
        updated: 'Contact updated.',
        deleted: 'Contact deleted.',
        delete: 'Delete contact',
        deleteTitle: 'Delete contact',
        deleteDescription: 'The contact will be removed from the customer record.',
        error: 'The contact could not be saved.',
        loadError: 'The contacts could not be loaded.',
      },
      notes: {
        add: 'Add note',
        subject: 'Subject',
        body: 'Note',
        created: 'Note saved.',
        error: 'The note could not be saved.',
      },
      calls: {
        createTitle: 'Log call',
        description: 'Document outcome, duration and follow-up of the call.',
        direction: 'Direction',
        outcome: 'Outcome',
        subject: 'Subject',
        contact: 'Contact',
        occurredAt: 'Time',
        durationSeconds: 'Duration (seconds)',
        notes: 'Call notes',
        created: 'Call saved.',
        error: 'The call could not be saved.',
        directions: {
          INBOUND: 'Inbound',
          OUTBOUND: 'Outbound',
        },
        outcomes: {
          REACHED: 'Reached',
          NOT_REACHED: 'Not reached',
          CALLBACK: 'Callback agreed',
          ORDER_PLACED: 'Order placed',
          COMPLAINT: 'Complaint',
          NO_INTEREST: 'No interest',
        },
      },
      quotes: {
        createTitle: 'Create quote',
        description: 'Creates a draft quote using the terms of this customer.',
        reference: 'Reference',
        validDays: 'Validity (days)',
        submit: 'Create quote',
        created: 'Quote created.',
        error: 'The quote could not be created.',
      },
      documents: {
        empty: 'No documents yet.',
        error: 'The documents could not be loaded.',
      },
      activities: {
        empty: 'No activities yet.',
        error: 'The history could not be loaded.',
        types: {
          DOCUMENT: 'Documents',
          NOTE: 'Notes',
          CALL: 'Calls',
        },
      },
      customFields: {
        title: 'Dynamic custom fields',
        subtitle: 'Fields are configured right here and are available immediately.',
        empty: 'No custom fields defined yet.',
        saved: 'Custom fields saved.',
      },
    },
    inventory: {
      expiringWidget: {
        title: 'Expiry warnings',
        description: 'Batches with a remaining shelf life of {{days}} days or less.',
        empty: 'No batch is expiring soon.',
        error: 'The expiry warnings could not be loaded.',
        entry: 'Batch {{batch}} · {{quantity}} · location {{location}}',
        open: 'Open',
        openBatch: 'Open batch {{batch}} in the product',
        openProducts: 'Go to products',
        showAll: 'Show all affected products',
      },
    },
    products: {
      title: 'Products',
      subtitle: 'Master data, prices, packagings and batch stock.',
      searchPlaceholder: 'Article number, name or GTIN …',
      searchLabel: 'Search products',
      createTitle: 'Create product',
      editTitle: 'Edit product',
      formDescription: 'All values apply to the current tenant.',
      created: 'Product created.',
      updated: 'Product saved.',
      saveError: 'The product could not be saved.',
      columnsMenu: 'Columns',
      decimals: {
        hint: 'Use a decimal point or comma: 47.45 and 47,45 are equal. 47. or 47, is saved as 47. Do not enter thousands separators.',
        moneyError:
          'Enter a valid number with at most 4 decimal places; a point or comma is allowed.',
        percentError:
          'Enter a value from 0 to 100 with at most 6 decimal places; a point or comma is allowed.',
        quantityError:
          'Enter a non-negative number with at most 6 decimal places; a point or comma is allowed.',
      },
      texts: {
        translatedName: 'Name ({{language}})',
        translatedDescription: 'Description ({{language}})',
        languageLabel: 'Product text language',
        optionalHint:
          'Translations are optional. German texts are used when a translation is missing.',
        validationSummary: 'Please check the highlighted fields. Your entries are preserved.',
        nameRequired: 'Please enter the German name.',
        nameTooLong: 'The name must contain no more than 200 characters.',
        descriptionTooLong: 'The description must contain no more than 4000 characters.',
      },
      tabs: {
        master: 'Master data & prices',
        images: 'Images',
        priceTiers: 'Price tiers',
        specifications: 'Specifications',
        packagings: 'Packagings',
        batches: 'Batches & expiry',
        movements: 'Stock history',
      },
      detail: {
        stockSummary: 'Stock {{stock}} {{unit}} · available {{available}} {{unit}}',
      },
      badges: {
        batchManaged: 'Batch managed',
        belowMinStock: 'Below minimum stock',
      },
      actions: {
        create: 'Create product',
        export: 'Export',
        bulkPrice_one: 'Update prices ({{count}})',
        bulkPrice_other: 'Update prices ({{count}})',
        adjustStock: 'Adjust stock',
        backToList: 'Back to list',
      },
      export: {
        csv: 'Download CSV',
        xlsx: 'Download Excel',
        success: 'Export created.',
        error: 'The export failed.',
      },
      states: {
        empty: 'No products yet.',
        emptyFiltered: 'No products match the current filters.',
        error: 'The products could not be loaded.',
        detailError: 'The product could not be loaded.',
      },
      selection: {
        toggleAll: 'Select all products on this page',
        toggleRow: 'Select {{name}}',
      },
      columns: {
        icon: 'Kind',
        image: 'Image',
        articleNumber: 'Article no.',
        name: 'Name',
        productGroup: 'Product group',
        productGroupLegacy: 'Product group (compatibility field)',
        stock: 'Stock',
        available: 'Available',
        listPrice: 'List price',
        purchasePrice: 'Cost',
        batches: 'Batches',
        status: 'Status',
        tags: 'Tags',
      },
      batchBadge: {
        count_one: '{{count}} batch',
        count_other: '{{count}} batches',
        expiring_one: '{{count}} expiry warning',
        expiring_other: '{{count}} expiry warnings',
      },
      filters: {
        criticalStock: 'Critical stock',
        expiring: 'Expiry warnings (< {{days}} days)',
        activeOnly: 'Active products only',
        status: 'Status',
        type: 'Product type',
        productGroup: 'Product group',
        batchManaged: 'Batch tracking',
        batchManagedOnly: 'Batch managed only',
        batchManagedNone: 'Without batch tracking',
        reset: 'Reset filters',
      },
      sections: {
        base: 'Master data',
        prices: 'Prices & planning',
        logistics: 'Logistics & customs',
        batches: 'Batches & expiry',
        customFields: 'Custom fields',
      },
      fields: {
        articleNumber: 'Article number',
        articleNumberHint: 'Leave empty to draw the next number from the range.',
        name: 'Name',
        nameEn: 'Name (EN)',
        description: 'Description',
        type: 'Product type',
        status: 'Status',
        ean: 'GTIN/EAN',
        manufacturerNumber: 'Manufacturer number',
        productGroup: 'Product group',
        baseUnit: 'Base unit',
        taxRateType: 'Tax rate',
        taxRatePct: 'Tax rate (%)',
        currency: 'Currency',
        listPrice: 'Sales price',
        purchasePrice: 'Purchase price',
        minMarginPct: 'Minimum margin (%)',
        marginHint: 'Current margin: {{value}}',
        weightNetKg: 'Net weight (kg)',
        weightGrossKg: 'Gross weight (kg)',
        commodityCode: 'Commodity code',
        commodityCodeHint: 'Customs tariff number with 8, 10 or 11 digits.',
        countryOfOrigin: 'Country of origin',
        minStock: 'Minimum stock',
        reorderPoint: 'Reorder point',
        targetStock: 'Target stock',
        leadTimeDays: 'Lead time (days)',
        isBatchManaged: 'Batch managed',
        isShelfLifeManaged: 'Shelf life managed',
        shelfLifeDays: 'Shelf life (days)',
        shelfLifeDaysHint: 'Used to prefill the expiry date of new batches.',
        minRemainingShelfLifeDays: 'Minimum remaining shelf life (days)',
        pickingStrategy: 'Picking strategy',
        tags: 'Tags',
        tagsHint: 'Separate multiple values with commas.',
      },
      statuses: {
        ARCHIVED: 'Archived',
        ACTIVE: 'Active',
        PHASE_OUT: 'Phasing out',
        DISCONTINUED: 'Discontinued',
        BLOCKED: 'Blocked',
      },
      types: {
        STOCK: 'Stock item',
        NON_STOCK: 'Non-stock item',
        SERVICE: 'Service',
        SET: 'Bill of materials',
        DEPOSIT: 'Deposit',
      },
      taxRateTypes: {
        STANDARD: 'Standard rate',
        REDUCED: 'Reduced rate',
        ZERO: 'Zero rate',
      },
      pickingStrategies: {
        FEFO: 'FEFO (first expired, first out)',
        FIFO: 'FIFO (first in, first out)',
        MANUAL: 'Manual selection',
      },
      images: {
        title: 'Product images',
        gallery: 'Image gallery',
        empty: 'No images have been added to this product yet.',
        loadError: 'The product images could not be loaded.',
        drop: 'Drop images here or select files',
        detected: '{{count}} file(s) detected',
        remaining: '{{count}} image slot(s) left · JPEG, PNG, WebP or AVIF',
        choose: 'Choose files',
        camera: 'Use camera',
        invalidSelection:
          'At least one file is invalid or the maximum image count would be exceeded.',
        removePending: 'Remove {{name}} from the selection',
        partialUploadError:
          '{{count}} image(s) could not be uploaded. The product was saved; retry only these files.',
        limits: 'JPEG, PNG, WebP or AVIF · maximum 20 MB · up to {{count}} images',
        count: '{{current}} of {{max}} images',
        progress: 'Upload: {{progress}}%',
        uploadStates: {
          PENDING: 'Waiting',
          UPLOADING: 'Uploading: {{progress}}%',
          SUCCESS: 'Uploaded',
          FAILED: 'Failed — retry when saving',
        },
        uploaded: '{{count}} image(s) uploaded.',
        uploadError: 'The images could not be uploaded.',
        emptyFile: 'The file is empty.',
        fileTooLarge: 'The file exceeds 20 MB.',
        unsupportedFormat: 'Only JPEG, PNG, WebP and AVIF are supported.',
        tooMany: 'A product can have at most {{count}} images.',
        selection: 'Selection',
        select: 'Select {{title}}',
        primary: 'Primary image',
        makePrimary: 'Make primary image',
        primarySet: 'Primary image changed.',
        fullscreen: 'Full screen',
        original: 'View original',
        replace: 'Replace image',
        replaced: 'Image replaced.',
        deleteTitle: 'Delete product image?',
        deleteDescription:
          '“{{name}}” and its original and presentation variants will be permanently removed.',
        deleted: 'Image deleted.',
        deleteError: 'The image could not be deleted.',
        sorted: 'Image order saved.',
        sortError: 'The image order could not be saved.',
        editTitle: 'Edit image details',
        editDescription: 'Title and alternative text support accessible presentation.',
        imageTitle: 'Image title',
        altText: 'Alternative text',
        altHint: 'Briefly and objectively describe the visible image content.',
        updated: 'Image details saved.',
        updateError: 'The image could not be updated.',
        retrySuccess: 'Image variants regenerated.',
      },
      categories: {
        action: 'Manage categories',
        title: 'Product categories',
        description: 'Structure tenant-specific categories hierarchically and assign products.',
        tree: 'Category tree',
        editor: 'Edit category',
        search: 'Search categories …',
        showInactive: 'Show inactive categories',
        empty: 'No matching categories yet.',
        loadError: 'The categories could not be loaded.',
        createRoot: 'Create root category',
        createChild: 'Create subcategory below {{name}}',
        createTitle: 'Create category',
        editTitle: 'Edit category',
        expand: 'Expand {{name}}',
        collapse: 'Collapse {{name}}',
        productCount: '{{count}} products',
        inactive: 'Inactive',
        active: 'Active',
        name: 'Name',
        nameEn: 'Name (English)',
        categoryDescription: 'Description',
        parent: 'Parent category',
        root: 'Top level',
        sortOrder: 'Sort order',
        archive: 'Archive',
        archiveTitle: 'Archive product category?',
        archiveDescription:
          '“{{name}}” will be deactivated and removed from the active category navigation.',
        archived: 'Category archived.',
        archiveError: 'The category could not be archived.',
        created: 'Category created.',
        updated: 'Category saved.',
        saveError: 'The category could not be saved.',
        assignments: 'Categories',
        selected: '{{count}} category/categories selected',
        primary: 'Primary category',
        makePrimary: 'Make {{name}} the primary category',
      },
      batchStatuses: {
        FREE: 'Free',
        QUARANTINE: 'Quarantine',
        BLOCKED: 'Blocked',
        EXPIRED: 'Expired',
        DEPLETED: 'Depleted',
      },
      movementTypes: {
        GOODS_RECEIPT: 'Goods receipt',
        GOODS_ISSUE: 'Goods issue',
        TRANSFER_IN: 'Transfer in',
        TRANSFER_OUT: 'Transfer out',
        ADJUSTMENT: 'Adjustment',
        INVENTORY_COUNT: 'Inventory count',
        SCRAP: 'Scrap',
        RETURN_IN: 'Customer return',
        RETURN_OUT: 'Supplier return',
      },
      referenceTypes: {
        MANUAL: 'Manual',
        ORDER: 'Order',
        DELIVERY_NOTE: 'Delivery note',
        INVOICE: 'Invoice',
        PURCHASE_ORDER: 'Purchase order',
        INVENTORY: 'Inventory',
        PRODUCTION: 'Production',
      },
      units: {
        PCE: 'pcs',
        KGM: 'kg',
        GRM: 'g',
        LTR: 'l',
        MLT: 'ml',
        MTR: 'm',
        MTQ: 'm³',
        MTK: 'm²',
        PA: 'pack',
      },
      packagingUnits: {
        BX: 'Box',
        CT: 'Carton',
        PF: 'Pallet',
        PK: 'Pack',
        TU: 'Tray',
        BG: 'Bag',
        CS: 'Case',
      },
      priceTiers: {
        add: 'Add tier',
        remove: 'Remove tier',
        empty: 'No price tiers defined yet.',
        saved: 'Price tiers saved.',
        saveError: 'The price tiers could not be saved.',
        calculate: 'Apply discount',
        calculatorHint: 'The discount is applied to the list price.',
        columns: {
          priceGroup: 'Price group',
          minQuantity: 'From quantity',
          unitPrice: 'Unit price',
          discountPct: 'Discount (%)',
          margin: 'Margin',
          validFrom: 'Valid from',
          validTo: 'Valid to',
        },
      },
      packagings: {
        add: 'Add packaging',
        remove: 'Remove packaging',
        empty: 'No packagings defined yet.',
        description: 'The conversion factor describes the quantity in {{unit}} per packaging.',
        saved: 'Packagings saved.',
        saveError: 'The packagings could not be saved.',
        fields: {
          code: 'Code',
          name: 'Name',
          unitCode: 'Packaging type',
          factor: 'Conversion factor',
          factorHint: 'Quantity in {{unit}} per packaging.',
          ean: 'Packaging GTIN',
          weightGrossKg: 'Gross weight (kg)',
          lengthMm: 'Length (mm)',
          widthMm: 'Width (mm)',
          heightMm: 'Height (mm)',
          minOrderQuantity: 'Minimum order quantity',
          orderStepQuantity: 'Order increment',
          isSalesDefault: 'Sales default',
          isPurchaseDefault: 'Purchase default',
        },
      },
      batches: {
        create: 'Add batch',
        empty: 'No batches yet.',
        error: 'The batches could not be loaded.',
        notManaged: 'This product is not batch managed.',
        includeDepleted: 'Show depleted batches',
        totalRemaining: 'Total stock {{value}} {{unit}}',
        daysLeft_one: '{{count}} day left',
        daysLeft_other: '{{count}} days left',
        block: 'Block',
        release: 'Release',
        blocked: 'Batch {{batch}} blocked.',
        released: 'Batch {{batch}} released.',
        blockTitle: 'Block batch',
        blockDescription: 'Batch {{batch}} will be blocked for issues.',
        blockReason: 'Reason',
        releaseReason: 'Released after inspection',
        updateError: 'The batch could not be updated.',
        customFieldsEditTitle: 'Edit batch custom fields',
        customFieldsEditDescription: 'Additional data for batch {{batch}}.',
        customFieldsSaved: 'Batch custom fields saved.',
        levels: {
          EXPIRED: 'Expired',
          CRITICAL: 'Critical',
          WARNING: 'Warning',
          OK: 'Uncritical',
        },
        columns: {
          batchNumber: 'Batch',
          bestBeforeDate: 'Best before',
          remainingShelfLife: 'Remaining shelf life',
          remaining: 'Remaining quantity',
          storageLocation: 'Storage location',
          status: 'Status',
          actions: 'Actions',
        },
      },
      batchDialog: {
        title: 'Add batch',
        description: 'Goods receipt for {{name}}.',
        submit: 'Add batch',
        created: 'Batch {{batch}} added.',
        error: 'The batch could not be created.',
        fields: {
          batchNumber: 'Batch number',
          quantity: 'Quantity ({{unit}})',
          productionDate: 'Production date',
          bestBeforeDate: 'Best before date',
          bestBeforeHint: 'Suggested from a shelf life of {{days}} days.',
          storageLocation: 'Storage location',
          warehouseCode: 'Warehouse',
          supplierBatchNumber: 'Supplier batch',
          certificateRef: 'Certificate',
          countryOfOrigin: 'Country of origin',
          unitCost: 'Unit cost',
          referenceType: 'Reference type',
          notes: 'Notes',
        },
      },
      adjustment: {
        title: 'Stock adjustment',
        description: '{{name}} · current stock {{stock}}',
        modeLabel: 'Posting type',
        modes: {
          DELTA: 'Adjustment quantity',
          COUNT: 'Counted stock',
        },
        submit: 'Post',
        success: 'Stock adjusted.',
        newStock: 'New stock: {{value}}',
        error: 'The posting failed.',
        fields: {
          quantity: 'Adjustment quantity',
          quantityHint: 'Positive values add stock, negative values remove it.',
          countedQuantity: 'Counted stock',
          countedQuantityHint: 'The difference to the book stock is posted automatically.',
          batch: 'Batch',
          warehouseCode: 'Warehouse',
          reason: 'Reason',
          reasonHint: 'Mandatory, at least {{min}} characters (audit proof).',
        },
      },
      movements: {
        description: 'All stock movements in audit-proof order.',
        empty: 'No movements posted yet.',
        error: 'The stock history could not be loaded.',
        filterType: 'Movement type',
        balanceAfter: 'Balance after: {{value}}',
        entry: '{{date}} · {{user}} · {{reference}}',
      },
      bulkPrice: {
        title: 'Update prices',
        description: 'The change is applied to {{count}} selected products.',
        submit: 'Update prices',
        success: '{{updated}} products updated, {{skipped}} skipped.',
        error: 'The price update failed.',
        targets: {
          LIST_PRICE: 'Sales price',
          PURCHASE_PRICE: 'Purchase price',
        },
        modes: {
          PERCENT: 'Change by percent',
          ABSOLUTE: 'Add amount',
          SET: 'Set fixed price',
        },
        valueLabels: {
          PERCENT: 'Change in percent',
          ABSOLUTE: 'Change as amount',
          SET: 'New price',
        },
        fields: {
          target: 'Price field',
          mode: 'Calculation',
          roundTo: 'Decimal places',
          reason: 'Reason',
          reasonHint: 'Stored in the audit log.',
        },
      },
    },
    documents: {
      packaging: {
        baseUnitPriceColumn: 'Piece / base price',
        baseUnitPriceLabel: 'Price per {{unit}}',
        baseUnitPriceInvalid:
          'Enter a valid price with up to four decimal places. The converted packaging price must also be within the allowed range.',
        baseUnitPrice: 'Price per {{unit}}: {{price}}',
        label: 'Unit / packaging',
        conversion: '{{quantity}} {{packaging}} = {{baseQuantity}} {{baseUnit}}',
        historic: 'saved',
        loading: 'Loading packaging …',
        loadError: 'Packaging could not be loaded.',
        pricing: 'Calculating price …',
        priceError: 'Price unconfirmed. Check the quantity and packaging and try again.',
        saveBlocked: 'Load the packaging and complete pricing successfully before saving.',
        invalid: 'Enter a valid quantity.',
        minimum: 'The minimum quantity is {{value}} of the selected unit.',
        step: 'The quantity must be a multiple of {{value}} of the selected unit.',
      },
      legacyCustomFieldsNotice:
        'Historical definitions for this document’s custom fields are unavailable. These fields are not reinterpreted. Please use the original printout.',
      title: 'Documents',
      subtitle: 'Quotations, orders, delivery notes and invoices along the document chain.',
      tabs: {
        all: 'All',
      },
      catalog: {
        mode: 'Item view',
        tab: 'Catalog',
        positionsTab: 'Items',
        customerRequired: 'Please select a customer first.',
        selectCustomerHint:
          'You can browse the catalog. Select a customer before calculating binding prices or adding an item.',
        categories: 'Categories',
        categoriesDescription: 'Select a category to narrow the catalog.',
        categoriesError: 'The categories could not be loaded.',
        allProducts: 'All products',
        expandCategory: 'Expand {{name}}',
        collapseCategory: 'Collapse {{name}}',
        breadcrumb: 'Category path',
        search: 'Article number, EAN, name, description or tag …',
        filters: 'Filters',
        reset: 'Reset filters',
        activeOnly: 'Active products only',
        availableOnly: 'Available products only',
        productType: 'Product type',
        allTypes: 'All product types',
        stockStatus: 'Stock status',
        allStockStatuses: 'All stock statuses',
        stockStatuses: {
          AVAILABLE: 'Available',
          LOW: 'Low stock',
          OUT_OF_STOCK: 'Unavailable',
          NOT_MANAGED: 'Not stock-managed',
        },
        manufacturer: 'Manufacturer',
        minPrice: 'Minimum price',
        maxPrice: 'Maximum price',
        sort: 'Sort order',
        sortOptions: {
          name_asc: 'Name ascending',
          name_desc: 'Name descending',
          articleNumber_asc: 'Article number ascending',
          articleNumber_desc: 'Article number descending',
          price_asc: 'Price ascending',
          price_desc: 'Price descending',
          stock_asc: 'Stock ascending',
          stock_desc: 'Stock descending',
          lastUsed_desc: 'Recently used',
          updatedAt_desc: 'Recently updated',
        },
        grid: 'Grid view',
        list: 'List view',
        loadError: 'The catalog could not be loaded.',
        empty: 'No products match this selection.',
        batch: 'Batch',
        ean: 'EAN',
        available: 'Available',
        reserved: 'Reserved',
        notManaged: 'Not stock-managed',
        customerPrice: 'Customer price',
        listPrice: 'List price',
        packaging: 'Packaging unit',
        baseUnit: 'Base unit ({{unit}})',
        baseQuantity: 'Equals {{quantity}} {{unit}} base quantity',
        quantity: 'Quantity',
        decrease: 'Decrease quantity',
        increase: 'Increase quantity',
        add: 'Add',
        addedShort: 'Added',
        added: 'Product added to the order.',
        addError: 'The product could not be added.',
        inOrder: 'In order: {{quantity}} {{unit}}',
        shortfall: 'The requested base quantity exceeds available stock.',
      },
      types: {
        QUOTE: 'Quotation',
        ORDER: 'Order',
        DELIVERY_NOTE: 'Delivery note',
        INVOICE: 'Invoice',
        CANCELLATION: 'Cancellation invoice',
        CREDIT_NOTE: 'Credit note',
        PURCHASE_ORDER: 'Purchase order',
      },
      statuses: {
        DRAFT: 'Draft',
        SENT: 'Sent',
        ACCEPTED: 'Accepted',
        REJECTED: 'Rejected',
        CONFIRMED: 'Confirmed',
        IN_PROGRESS: 'In progress',
        PARTIALLY_PROCESSED: 'Partially processed',
        SHIPPED: 'Shipped',
        COMPLETED: 'Completed',
        POSTED: 'Posted',
        CANCELLED: 'Cancelled',
      },
      paymentStatuses: {
        OPEN: 'Open',
        PARTIALLY_PAID: 'Partially paid',
        PAID: 'Paid',
        OVERDUE: 'Overdue',
        WRITTEN_OFF: 'Written off',
      },
      taxStrategies: {
        REGULAR: 'Standard taxation',
        REVERSE_CHARGE: 'Reverse charge',
        INTRA_COMMUNITY: 'Intra-community supply',
        EXPORT_NON_EU: 'Export (non-EU)',
      },
      taxDetermination: {
        title: 'Explainable tax determination',
        loading: 'Checking the tax recommendation …',
        unavailable: 'Tax recommendation is currently unavailable',
        selectCustomer: 'Select a customer, delivery mode and items to receive a recommendation.',
        suggestion: 'Recommendation',
        applySuggestion: 'Apply recommendation',
        reasonsTitle: 'Decision reasons',
        actionsTitle: 'Outstanding checks and evidence',
        noActions: 'No outstanding checks detected.',
        overrideReason: 'Reason for the different decision',
        overridePlaceholder: 'Record the reviewed business reason (at least 10 characters)',
        overrideForbidden: 'Only authorized roles may deviate from the recommendation.',
        disclaimer:
          'This recommendation supports document review but is not tax or legal advice. Special cases such as chain and triangular transactions require specialist review.',
        deliveryMode: 'Delivery mode',
        deliveryModes: { SHIPMENT: 'Shipment', PICKUP: 'Pickup', UNKNOWN: 'Not decided yet' },
        assessments: {
          ELIGIBLE: 'Prerequisites detected',
          NOT_ELIGIBLE: 'Prerequisites not met',
          REVIEW_REQUIRED: 'Review required',
        },
        reasons: {
          CROSS_BORDER_EU_DESTINATION: 'The destination is in another EU member state.',
          DOMESTIC_DESTINATION: 'The destination is in the seller country.',
          DESTINATION_NOT_EU: 'The destination is outside the EU.',
          DESTINATION_MISSING: 'The actual destination has not been confirmed.',
          SELLER_NOT_EU: 'The seller was not in an EU member state on the document date.',
          CUSTOMER_IS_COMPANY: 'The customer is recorded as a company.',
          CUSTOMER_NOT_COMPANY: 'The customer is not recorded as a company.',
          CUSTOMER_CONFIGURED_EU_B2B: 'The customer is configured as EU B2B.',
          CUSTOMER_NOT_CONFIGURED_EU_B2B: 'The customer tax category is not EU B2B.',
          VAT_ID_VALID_AND_CURRENT: 'The current VAT ID has current VIES evidence.',
          VAT_ID_MISSING: 'The customer has no VAT ID.',
          VAT_ID_INVALID: 'The latest VAT ID check was not valid.',
          VAT_ID_COUNTRY_MISMATCH: 'The VAT ID prefix does not match the destination.',
          VAT_VALIDATION_MISSING: 'No VIES check is available.',
          VAT_VALIDATION_STALE: 'The VIES evidence is stale or uses a legacy mapping.',
          VAT_VALIDATION_UNAVAILABLE:
            'VIES was unavailable; this does not count as valid evidence.',
          VAT_ID_CHANGED_SINCE_DOCUMENT_SNAPSHOT:
            'The VAT ID changed since the previous document snapshot.',
          BILLING_AND_DESTINATION_DIFFER: 'Billing and actual destination countries differ.',
          GOODS_SUPPLY: 'The items were identified as a supply of goods.',
          SERVICE_SUPPLY_REVIEW: 'Services require a separate place-of-supply and tax review.',
          MIXED_SUPPLY_REVIEW: 'Goods and services are mixed and require separate review.',
          SUPPLY_TYPE_UNKNOWN: 'The supply type is not yet clear.',
          PICKUP_REVIEW: 'Cross-border movement needs separate evidence for pickup.',
          DELIVERY_MODE_UNKNOWN: 'The delivery mode has not been decided.',
          TRANSPORT_EVIDENCE_AVAILABLE: 'Linked shipping or customs evidence is available.',
          TRANSPORT_EVIDENCE_REQUIRED: 'Shipping evidence is still required for the exemption.',
          EXISTING_EXPORT_CONFIGURATION: 'The customer export configuration was considered.',
          EXISTING_REVERSE_CHARGE_CONFIGURATION:
            'The existing reverse-charge configuration was considered.',
          MASTER_FACTS_INCOMPLETE:
            'Current master or address facts are missing for the tax assessment.',
          SPECIAL_CASE_REVIEW: 'This case is not automated and requires specialist review.',
        },
        actions: {
          VERIFY_VAT_ID: 'Run a current VIES VAT ID check.',
          CONFIRM_DESTINATION: 'Confirm the actual destination.',
          COLLECT_TRANSPORT_EVIDENCE: 'Link a delivery note or reliable shipping/customs evidence.',
          REVIEW_SUPPLY_TYPE: 'Review the goods or service classification.',
          REVIEW_PICKUP_OR_SPECIAL_CASE: 'Have a specialist review the pickup or special case.',
          COMPLETE_MASTER_FACTS: 'Review and complete the indicated master or address facts.',
          PROVIDE_OVERRIDE_REASON: 'Explain the different tax decision.',
        },
      },
      paymentMethods: {
        INVOICE: 'Invoice (payment on account)',
        PREPAYMENT: 'Prepayment',
        CASH: 'Cash',
      },
      languages: {
        tr: 'Turkish',
        es: 'Spanish',
        de: 'German',
        en: 'English',
        fr: 'French',
      },
      languageFallback:
        'No built-in template is available for this language. German is used unless the tenant provides a template.',
      columns: {
        number: 'Document no.',
        type: 'Type',
        customer: 'Customer',
        documentDate: 'Document date',
        dueDate: 'Due',
        status: 'Status',
        grossTotal: 'Gross',
      },
      filters: {
        search: 'Search documents',
        searchPlaceholder: 'Document number, reference or customer …',
        status: 'Status',
        allStatuses: 'All statuses',
        dateFrom: 'Document date from',
        dateTo: 'Document date to',
        payment: {
          ALL: 'All',
          OPEN: 'Open',
          OVERDUE: 'Overdue',
          PAID: 'Paid',
        },
      },
      actions: {
        create: 'New document',
        lock: 'Post document',
        sendEmail: 'Send by e-mail',
        convertTo: {
          QUOTE: 'Convert to quotation',
          ORDER: 'Convert to order',
          DELIVERY_NOTE: 'Create delivery note',
          INVOICE: 'Create invoice',
          CANCELLATION: 'Cancel',
          CREDIT_NOTE: 'Create credit note',
          PURCHASE_ORDER: 'Create purchase order',
        },
      },
      states: {
        empty: 'No documents yet.',
        pagination: 'Page {{page}} of {{totalPages}} · {{total}} documents',
      },
      editor: {
        back: 'Back to list',
        newTitle: 'New document',
        newSubtitle: 'Pick a customer, add line items and save.',
        type: 'Document type',
        headSection: 'Document header',
        itemsSection: 'Line items',
        textsSection: 'Texts',
        customFieldsSection: 'Custom fields',
        customFieldsInvalid: 'check {{count}} field',
        customFieldsInvalid_other: 'check {{count}} fields',
        addCustomField: 'Add custom field',
        addCustomFieldHint: 'Search for a document field or filter the list by category.',
        removeCustomField: 'Remove {{field}} from the document',
        searchCustomFields: 'Search custom fields …',
        customFieldCategory: 'Custom field category',
        allCustomFieldCategories: 'All categories',
        uncategorizedFields: 'Uncategorised',
        noDocumentCustomFields: 'No custom fields configured for this document type.',
        noCustomFieldsSelected: 'No optional custom fields selected yet.',
        noCustomFieldsAvailable: 'No matching additional custom fields found.',
        itemCustomFieldColumns: 'Custom-field columns',
        customFieldsToast: 'Custom field error: {{field}} — {{reason}} [ID: {{id}}]',
        customFieldsMore: 'One more field is invalid as well.',
        customFieldsMore_other: '{{count}} more fields are invalid as well.',
        customerPlaceholder: 'Search customer …',
        noCustomers: 'No customers found.',
        incomplete: 'Please provide customer, recipient and at least one line item.',
        created: 'Document created.',
        saved: 'Document saved.',
        partialQuantities: 'Select partial quantities',
        conversionQuantitiesHint:
          'Without a selection, all remaining quantities are transferred. For partial quantities, 0 or an empty field skips the line. Existing transfers are checked when creating the document.',
        conversionQuantityInvalid: 'Enter at least one valid positive quantity.',
        converted: 'Follow-up document created.',
        convertFailed: 'Conversion to {{type}} failed',
        locked: 'Document posted.',
        customerLockedTitle: '🚨 Customer is locked for sales',
        customerLockedReason: 'Reason: {{reason}}',
        customerLockedHint:
          'No document may be created for this customer. Please contact accounting.',
        customerLockedOverride:
          'A release is only possible with the payment method prepayment or cash.',
        customerLockedSwitchToPrepayment: 'Switch to prepayment',
      },
      deliveryTerms: {
        replaceManualConfirmation:
          'Replace the manually entered delivery terms with the new address default?',
        reset: 'Reset to default',
        sources: {
          CUSTOMER_DEFAULT: 'Source: customer default',
          SHIPPING_ADDRESS: 'Source: shipping address',
          MANUAL: 'Source: manual override',
          NONE: 'No delivery terms set',
        },
      },
      quoteValidity: {
        automaticHint:
          'Automatic: {{days}} days from the document date. You can change or clear the date.',
        manualHint: 'Quote expiry date. Change it or leave it blank as needed.',
        loading: 'Loading default validity …',
        loadError: 'The default validity could not be loaded. Try again or set the date manually.',
      },
      fields: {
        customer: 'Customer',
        recipient: 'Recipient',
        documentDate: 'Document date',
        validUntil: 'Valid until',
        reference: 'Your reference',
        language: 'Document language',
        currency: 'Currency',
        taxStrategy: 'Tax determination',
        paymentMethod: 'Payment method',
        paymentTermsDays: 'Payment terms (days)',
        cashDiscountPct: 'Cash discount %',
        cashDiscountDays: 'Cash discount days',
        discountPct: 'Overall discount %',
        shippingAmount: 'Shipping',
        shippingAddress: 'Shipping address',
        noShippingAddress: 'No shipping address',
        searchShippingAddress: 'Search label, recipient or city',
        noMatchingShippingAddress: 'No matching shipping address found.',
        unnamedShippingAddress: 'Shipping address without details',
        deliveryTerms: 'Delivery terms',
        headerText: 'Header text',
        footerText: 'Footer text',
        internalNote: 'Internal note',
      },
      items: {
        position: 'Item',
        article: 'Article',
        articlePlaceholder: 'Search article …',
        noArticles: 'No articles found.',
        text: 'Free text',
        quantity: 'Quantity',
        unit: 'Unit',
        unitPrice: 'Unit price',
        discount: 'Discount %',
        taxRate: 'VAT %',
        lineNet: 'Net',
        remove: 'Remove line',
        addArticle: 'Article line',
        addText: 'Text line',
        batch: 'Batch',
        stock: 'Stock',
        selectBatch: 'Select batch',
      },
      totals: {
        title: 'Calculation',
        itemsNet: 'Line items net',
        discount: 'Overall discount {{pct}}',
        shipping: 'Shipping',
        net: 'Net amount',
        tax: 'VAT {{pct}} on {{base}}',
        gross: 'Total amount',
        cashDiscount:
          'Pay within {{days}} days: {{pct}} cash discount ({{amount}}) – payable {{payable}}.',
      },
      batchPicker: {
        title: 'Batch selection',
        description: 'Proposal for “{{product}}” based on the chosen picking strategy.',
        strategy: 'Strategy',
        bestBefore: 'Best before',
        apply: 'Apply',
        empty: 'No available batch found.',
        shortfall: 'Shortfall of {{quantity}} units.',
        levels: {
          EXPIRED: 'Expired',
          CRITICAL: 'Critical',
          WARNING: 'Warning',
          OK: 'Uncritical',
          UNKNOWN: 'No best-before date',
        },
      },
      preview: {
        title: 'PDF preview',
        refresh: 'Refresh preview',
        download: 'Download PDF',
        toggle: 'Toggle preview',
        stale: 'The preview shows the last saved state.',
      },
      email: {
        title: 'Send document',
        description: 'Send document {{number}} with the PDF attached.',
        to: 'Recipient',
        subject: 'Subject',
        body: 'Message',
        submit: 'Send bindingly',
        success: 'Document sent.',
        failed: 'Sending failed.',
      },
      delete: {
        title: 'Delete document',
        description: 'Draft {{number}} will be deleted. This action cannot be undone.',
        success: 'Document deleted.',
      },
    },
    users: {
      title: 'User management',
      subtitle: 'Accounts, roles and status within this tenant.',
      create: 'Add user',
      searchPlaceholder: 'Search name or email',
      error: 'The users could not be loaded.',
      columns: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        status: 'Status',
        twoFactor: '2FA',
        lastLogin: 'Last login',
      },
      status: {
        active: 'Active',
        inactive: 'Disabled',
        locked: 'Locked',
      },
      twoFactor: {
        on: 'Enabled',
        off: 'Disabled',
      },
      filters: {
        role: 'Filter by role',
        allRoles: 'All roles',
      },
      empty: {
        title: 'No users found',
        description: 'Adjust the search or create a new account.',
      },
      actions: {
        label: 'Actions',
        edit: 'Edit',
        unlock: 'Unlock',
        resetPassword: 'Reset password',
        resetTwoFactor: 'Reset 2FA',
      },
      fields: {
        email: 'Email',
        firstName: 'First name',
        lastName: 'Last name',
        phone: 'Phone',
        locale: 'Language',
        role: 'Role',
        isActive: 'Account active',
        selfRoleHint: 'You cannot change your own role.',
      },
      sheet: {
        createTitle: 'Add user',
        createDescription: 'The account receives a one-time initial password.',
        editTitle: 'Edit user',
        editDescription: 'Adjust master data, role and account status.',
        passwordHint:
          'The initial password is shown once after saving and must be changed at first login.',
      },
      credentials: {
        title: 'Initial password',
        description: 'Hand over to {{email}} once – it will not be shown again.',
        hint: 'The account must change this password at first login.',
      },
      toast: {
        created: 'User created.',
        updated: 'User saved.',
        unlocked: 'Account unlocked.',
        twoFactorReset: 'Two-factor authentication reset.',
      },
    },
    roles: {
      title: 'Roles & permissions',
      subtitle: 'Permission matrix per role; changes apply at the next sign-in.',
      list: 'Roles',
      create: 'Add role',
      error: 'The roles could not be loaded.',
      ownerHint: 'The owner role always holds every permission and cannot be edited.',
      permissionCount: '{{count}} permissions selected',
      fields: {
        name: 'Name',
        description: 'Description',
      },
      matrix: {
        resource: 'Area',
        toggleRow: 'All permissions for {{resource}}',
      },
      resources: {
        FEATURES: 'Features & modules',
        CUSTOMERS: 'Customers',
        PARTNER_RISK: 'Customer risk & locks',
        PRODUCTS: 'Products',
        BATCHES: 'Batches & stock',
        DOCUMENTS: 'Documents',
        DOCUMENT_CUSTOMER_HEADERS: 'Customer data in document headers',
        DMS: 'Document management',
        ACCOUNTING: 'Accounting',
        ANALYTICS: 'Reporting',
        EMPLOYEE_PERFORMANCE: 'Employee performance',
        SETTINGS: 'Settings',
        USERS: 'Users',
        TELEPHONY: 'Telephony & AI',
        ANALYSIS: 'Analysis and nutrition profiles',
        MANUFACTURING: 'Manufacturing',
        TRACEABILITY: 'Lot traceability',
        MRP: 'Material requirements planning',
        LABEL_MANAGEMENT: 'Label management',
        CUSTOM_FIELDS: 'Dynamic custom fields',
        INTRODUCTION: 'Introduction mode',
        SETUP: 'Tenant setup',
        BACKUPS: 'Backups & restore',
      },
      actions: {
        CREATE: 'Create',
        READ: 'Read',
        UPDATE: 'Update',
        DELETE: 'Delete',
        EXPORT: 'Export',
        APPROVE: 'Approve',
        RELEASE: 'Release production order',
        RESERVE: 'Reserve material',
        CONSUME: 'Post material',
        COMPLETE: 'Report production completion',
        SIMULATE: 'Simulate recall',
        BLOCK: 'Block lots',
        REVIEW: 'Review',
        MANAGE: 'Manage',
        ARCHIVE: 'Archive',
        ADMIN: 'Administer',
        USE: 'Place calls',
        VIEW: 'View',
        SET_LOCK: 'Apply lock',
        OVERRIDE_LOCK: 'Release lock',
        VIEW_OWN_LOGS: 'Own calls',
        VIEW_ALL_LOGS: 'All calls',
        VIEW_AI_SUMMARY: 'View AI analysis',
        EDIT_AI_SUMMARY: 'Edit AI analysis',
        MANAGE_SETTINGS: 'Manage settings',
        VIEW_COSTS: 'View costs',
        RUN: 'Run planning',
        CONFIGURE: 'Configure',
        CONVERT_PURCHASE: 'Create purchase draft',
        CONVERT_PRODUCTION: 'Create production draft',
        IMPORT: 'Run bulk import',
        ROLLBACK: 'Restore version',
        MANAGE_FIELDS: 'Manage fields',
        MANAGE_GROUPS: 'Manage categories',
        READ_CONFIDENTIAL: 'Read confidential fields',
        WRITE_CONFIDENTIAL: 'Edit confidential fields',
        VIEW_AUDIT: 'View change history',
        CREATE_SETTINGS: 'Create settings backup',
        CREATE_MASTER_DATA: 'Create master-data backup',
        CREATE_FULL: 'Create full backup',
        DOWNLOAD: 'Download backup',
        RESTORE: 'Restore backup',
        RESTORE_DRY_RUN: 'Restore dry run',
        VIEW_DEPLOYMENT: 'View deployment backups',
        DELETE_DETAILS: 'Delete customer details',
        EDIT_PRICES: 'Change prices and discounts',
        CANCEL: 'Cancel documents',
      },
      delete: {
        title: 'Delete role',
        description: 'The role “{{name}}” will be removed permanently.',
      },
      toast: {
        created: 'Role created.',
        updated: 'Role saved.',
        deleted: 'Role deleted.',
      },
    },
    profile: {
      title: 'My profile',
      subtitle: 'Personal details and language preference.',
      account: 'Account',
      emailChangeHint:
        'Changing your email requires your current password and disables email 2FA until the new address is confirmed.',
      role: 'Role',
      tenant: 'Tenant',
      saved: 'Profile saved.',
    },
    security: {
      title: 'Security',
      subtitle: 'Password, second factor and active sessions.',
      password: {
        title: 'Change password',
        description: 'At least 12 characters with upper and lower case, a digit and a symbol.',
        current: 'Current password',
        new: 'New password',
        confirm: 'Confirm new password',
        mismatch: 'The passwords do not match.',
        submit: 'Change password',
        changed: 'Password changed.',
        show: 'Show password',
        hide: 'Hide password',
        strengthLabel: 'Password strength',
        strength: {
          '0': 'Very weak',
          '1': 'Weak',
          '2': 'Fair',
          '3': 'Strong',
          '4': 'Very strong',
        },
        rules: {
          length: 'At least 12 characters',
          uppercase: 'One upper case letter',
          lowercase: 'One lower case letter',
          digit: 'One digit',
          special: 'One symbol',
        },
      },
      forceChange: {
        title: 'Password change required',
        description:
          'Your account was created with an initial password. Please choose your own password now.',
      },
      twoFactor: {
        title: 'Two-factor authentication',
        description: 'Additional protection via an authenticator app (TOTP).',
        active: 'Enabled',
        inactive: 'Disabled',
        enable: 'Enable',
        disable: 'Disable',
        enableTitle: 'Set up two-factor authentication',
        disableTitle: 'Disable two-factor authentication',
        disableDescription: 'Your password and a current code are required to confirm.',
        intro: 'You need an authenticator app such as 1Password, Aegis or Google Authenticator.',
        start: 'Start setup',
        steps: {
          scan: 'Step 1 of 3: start the setup.',
          verify: 'Step 2 of 3: scan the QR code and enter the code.',
          codes: 'Step 3 of 3: store the backup codes.',
        },
        qrAlt: 'QR code to set up the authenticator app',
        enterCode: 'Enter the code from the app',
        code: 'Verification code',
        backupHint:
          'These codes replace the second factor if you lose your device. Each code works once.',
        downloadCodes: 'Download backup codes',
        enabled: 'Two-factor authentication enabled.',
        disabled: 'Two-factor authentication disabled.',
        authenticator: 'Authenticator app (TOTP)',
        makePrimary: 'Make primary',
      },
      emailTwoFactor: {
        title: 'Enable email code',
        disableTitle: 'Disable email code',
        method: 'Email code',
        description: 'Confirm your password, then enter the code from the email.',
        disableDescription: 'Enter your password and a current authenticator or backup code.',
        secondFactor: 'Authenticator or backup code',
        sentTo: 'A security code was sent to {{email}}.',
        send: 'Send code',
        confirm: 'Enable',
        enabled: 'Email 2FA enabled.',
        disabled: 'Email 2FA disabled.',
        independenceWarning:
          'An authenticator app is usually more independent and secure than email, especially when both accounts are used on the same device.',
      },
      twoFactorPolicy: {
        title: 'Tenant 2FA policy',
        description: 'Control allowed methods and requirements for this tenant.',
        error: 'The security policy could not be loaded.',
        methods: { TOTP: 'Allow authenticator app', EMAIL: 'Allow email code' },
        required: 'Require two-factor authentication for all users',
        emailEnabled: 'Enable email 2FA for this tenant',
        privilegedTotp: 'Require TOTP for privileged roles',
        requiredRoles: 'Roles that require 2FA',
        roles: { OWNER: 'Owner', ADMIN: 'Administrator' },
        validity: 'Email code validity (minutes)',
        cooldown: 'Resend cooldown (seconds)',
      },
      sessions: {
        title: 'Active sessions',
        description: 'Devices currently signed in with this account.',
        empty: 'No active sessions.',
        error: 'The sessions could not be loaded.',
        current: 'This session',
        unknownDevice: 'Unknown device',
        revoke: 'Revoke',
        revokeOthers: 'Revoke all other sessions',
        revoked: 'Session revoked.',
        revokedOthers: 'All other sessions were revoked.',
      },
    },
    securityLog: {
      title: 'Security log',
      subtitle: 'Sign-ins, permission changes and security relevant events.',
      searchPlaceholder: 'Search email or IP address',
      filterEvent: 'Filter event',
      allEvents: 'All events',
      empty: 'No entries for the selected filters.',
      error: 'The log could not be loaded.',
      columns: {
        timestamp: 'Timestamp',
        event: 'Event',
        user: 'User',
        ip: 'IP address',
      },
      events: {
        LOGIN_SUCCESS: 'Sign-in successful',
        LOGIN_FAILED: 'Sign-in failed',
        LOGOUT: 'Sign-out',
        TWO_FACTOR_ENABLED: '2FA enabled',
        TWO_FACTOR_DISABLED: '2FA disabled',
        TWO_FACTOR_FAILED: '2FA failed',
        TWO_FACTOR_METHOD_CHANGED: '2FA method changed',
        TWO_FACTOR_RESET: '2FA reset',
        EMAIL_CHANGED: 'Email address changed',
        PASSWORD_CHANGED: 'Password changed',
        PASSWORD_RESET: 'Password reset',
        ACCOUNT_LOCKED: 'Account locked',
        ACCOUNT_UNLOCKED: 'Account unlocked',
        ROLE_UPDATED: 'Role changed',
        PERMISSIONS_MODIFIED: 'Permissions changed',
        SESSION_REVOKED: 'Session revoked',
        USER_CREATED: 'User created',
        USER_UPDATED: 'User updated',
      },
    },
    notifications: {
      title: 'Notifications',
      bell: 'Open notifications',
      bellWithCount: '{{count}} unread notifications',
      unread: 'Unread',
      open: 'Open',
      markAllRead: 'Mark all read',
      manage: 'Manage notifications',
      error: 'The notifications could not be loaded.',
      tabs: {
        all: 'All',
        unread: 'Unread',
        critical: 'Critical',
      },
      empty: {
        title: 'No notifications',
        description: 'New events appear here in real time.',
      },
      categories: {
        STOCK_LOW: 'Reorder level',
        BATCH_EXPIRING: 'Expiry warning',
        ORDER_CREATED: 'New order',
        INVOICE_OVERDUE: 'Overdue invoice',
        TASK_ASSIGNED: 'Follow-up',
        SYSTEM: 'System',
      },
    },
    notificationSettings: {
      title: 'Notifications',
      subtitle: 'Decide which events reach you and where.',
      matrixTitle: 'Delivery channels',
      matrixDescription:
        'The bell reports events instantly inside the app, email also reaches you elsewhere.',
      error: 'The settings could not be loaded.',
      autoSave: 'Changes are saved immediately.',
      saved: 'Setting saved.',
      columns: {
        event: 'Event',
        inApp: 'In-app bell',
        email: 'Instant email',
      },
      descriptions: {
        STOCK_LOW: 'Stock of an article reaches the reorder level.',
        BATCH_EXPIRING: 'A batch expires within the next 30 days.',
        ORDER_CREATED: 'A new order arrived or was confirmed.',
        INVOICE_OVERDUE: 'An invoice is open beyond its due date.',
        TASK_ASSIGNED: 'A call note with a follow-up was assigned to you.',
        SYSTEM: 'Security and system events of this tenant.',
      },
    },
    company: {
      title: 'Company',
      subtitle: 'Master data, bank details and document defaults.',
      error: 'The company data could not be loaded.',
      saved: 'Company data saved.',
      invalid: 'Please review the highlighted fields.',
      sections: {
        identity: 'Company',
        identityHint: 'These details appear in the document header and footer.',
        tax: 'Tax & banking',
        taxHint: 'Mandatory details per § 14 UStG plus the bank account for invoices.',
        layout: 'Document layout',
        layoutHint: 'Logo and accent colour appear on every generated PDF.',
        documents: 'Document defaults',
        documentsHint: 'Presets for new quotations and invoices.',
      },
      fields: {
        companyName: 'Company name',
        legalForm: 'Legal form',
        ownerName: 'Owner / managing director',
        street: 'Street and number',
        zip: 'Postal code',
        city: 'City',
        country: 'Country',
        phone: 'Phone',
        email: 'Email',
        website: 'Website',
        vatId: 'VAT ID',
        taxNumber: 'Tax number',
        commercialRegister: 'Commercial register',
        commercialRegisterHint: 'e.g. HRB 12345, Amtsgericht Stuttgart',
        bankName: 'Bank',
        iban: 'IBAN',
        bic: 'BIC',
        primaryColor: 'Primary colour',
        invoiceDueDays: 'Payment term in days',
        quoteValidityDays: 'Quotation validity in days',
        defaultEmailSender: 'Sender address for documents',
        defaultEmailSenderHint: 'Used as the reply address when sending documents.',
      },
      legalForms: {
        EINZELUNTERNEHMEN: 'Sole proprietorship',
        FREIBERUFLER: 'Freelancer',
        EK: 'e. K.',
        GBR: 'GbR',
        OHG: 'OHG',
        KG: 'KG',
        GMBH: 'GmbH',
        GMBH_CO_KG: 'GmbH & Co. KG',
        UG: 'UG (limited liability)',
        AG: 'AG',
        SE: 'SE',
        EG: 'eG',
        LTD: 'Ltd.',
        GESMBH: 'GesmbH (Austria)',
        AG_CH: 'AG (Switzerland)',
        SONSTIGE: 'Other',
      },
      logo: {
        empty: 'No logo',
        preview: 'Logo preview',
        select: 'Choose logo',
        remove: 'Remove logo',
        hint: 'PNG, JPEG or SVG up to {{size}} KB.',
        invalidType: 'Allowed formats are PNG, JPEG and SVG.',
        tooLarge: 'The file exceeds {{size}} KB.',
      },
      color: {
        custom: 'Pick a custom colour',
        previewTitle: 'Invoice RE-2026-00001',
        previewHint: 'Document header and table rules',
      },
    },
    accounting: {
      periods: {
        lastMonth: 'Last month',
        currentMonth: 'Current month',
        q1: 'Q1',
        q2: 'Q2',
        q3: 'Q3',
        q4: 'Q4',
        currentYear: 'Current year',
        custom: 'Custom range',
        from: 'From',
        to: 'To',
      },
      months: {
        '1': 'January',
        '2': 'February',
        '3': 'March',
        '4': 'April',
        '5': 'May',
        '6': 'June',
        '7': 'July',
        '8': 'August',
        '9': 'September',
        '10': 'October',
        '11': 'November',
        '12': 'December',
      },
      federalStates: {
        '01': 'Schleswig-Holstein',
        '02': 'Hamburg',
        '03': 'Lower Saxony',
        '04': 'Bremen',
        '05': 'North Rhine-Westphalia',
        '06': 'Hesse',
        '07': 'Rhineland-Palatinate',
        '08': 'Baden-Württemberg',
        '09': 'Bavaria',
        '10': 'Saarland',
        '11': 'Berlin',
        '12': 'Brandenburg',
        '13': 'Mecklenburg-Western Pomerania',
        '14': 'Saxony',
        '15': 'Saxony-Anhalt',
        '16': 'Thuringia',
      },
      natureOfTransaction: {
        '11': 'Outright purchase/sale',
        '12': 'Goods on approval or trial',
        '21': 'Return of goods',
        '22': 'Replacement for returned goods',
        '23': 'Replacement for goods not returned',
        '31': 'Delivery under aid programmes',
        '41': 'Processing, return expected',
        '51': 'Return after processing',
        '91': 'Hire, loan or lease over 24 months',
        '99': 'Other transactions',
      },
      modeOfTransport: {
        '1': 'Sea transport',
        '2': 'Rail transport',
        '3': 'Road transport',
        '4': 'Air transport',
        '5': 'Postal consignment',
        '7': 'Fixed transport installations',
        '8': 'Inland waterway',
        '9': 'Own propulsion',
      },
      datev: {
        title: 'DATEV export',
        subtitle: 'EXTF booking batch for hand-over to the tax advisor.',
        openSettings: 'Configuration',
        periodSection: 'Period and document selection',
        reconciliation: 'Reconciliation: debit {{debit}} · credit {{credit}}',
        tabs: {
          export: 'Export',
          history: 'Export history',
        },
        filters: {
          includeCancellations: 'Include cancellation invoices and credit notes',
          includeAlreadyExported: 'Include already exported documents (repeat run)',
        },
        kpi: {
          records: 'Booking records',
          documents: 'Documents',
          net: 'Net volume',
          gross: 'Gross volume',
        },
        columns: {
          date: 'Document date',
          number: 'Document no.',
          customer: 'Customer',
          account: 'Account',
          contraAccount: 'Contra account',
          buKey: 'Tax key',
          net: 'Net',
          tax: 'VAT',
          gross: 'Gross',
          debitCredit: 'D/C',
          state: 'Status',
        },
        state: {
          locked: 'Posted',
          open: 'Open',
        },
        states: {
          empty: 'No exportable documents in the selected period.',
        },
        validation: {
          clean: 'All documents of the period are ready for export.',
          invalidRange: 'The start date must not be after the end date.',
          openCustomer: 'Open customer',
          openDocument: 'Open document {{number}}',
        },
        issues: {
          DEBTOR_ACCOUNT_MISSING_one: '{{count}} document without a debtor account.',
          DEBTOR_ACCOUNT_MISSING_other: '{{count}} documents without a debtor account.',
          REVENUE_ACCOUNT_MISSING_one: '{{count}} document without a mapped revenue account.',
          REVENUE_ACCOUNT_MISSING_other: '{{count}} documents without a mapped revenue account.',
          VAT_ID_MISSING_one: '{{count}} zero-rated EU supply without the customer VAT ID.',
          VAT_ID_MISSING_other: '{{count}} zero-rated EU supplies without the customer VAT ID.',
          DOCUMENT_NOT_LOCKED_one:
            '{{count}} document is not posted yet and will be posted on export.',
          DOCUMENT_NOT_LOCKED_other:
            '{{count}} documents are not posted yet and will be posted on export.',
          DOCUMENT_ALREADY_EXPORTED_one: '{{count}} document has already been handed over.',
          DOCUMENT_ALREADY_EXPORTED_other: '{{count}} documents have already been handed over.',
          SETTINGS_INCOMPLETE_one: 'Consultant and client number are missing in the configuration.',
          SETTINGS_INCOMPLETE_other:
            'Consultant and client number are missing in the configuration.',
          AMOUNT_ZERO_one: '{{count}} document without any amount-bearing line.',
          AMOUNT_ZERO_other: '{{count}} documents without any amount-bearing line.',
        },
        export: {
          action: 'Export booking batch (.csv)',
          success: 'Booking batch created and downloaded.',
        },
        history: {
          exportedAt: 'Exported at',
          period: 'Period',
          filename: 'File',
          records: 'Records / documents',
          volume: 'Gross volume',
          checksum: 'Checksum',
          download: 'Download again',
          repeat: 'Repeat',
          empty: 'No booking batch has been exported yet.',
          hint: 'The checksum proves that the regenerated file matches the archived run.',
        },
      },
      settings: {
        title: 'Accounting configuration',
        subtitle: 'Chart of accounts, DATEV master data and Intrastat defaults.',
        chartSection: 'Chart of accounts and DATEV master data',
        mappingSection: 'Revenue accounts per tax case',
        intrastatSection: 'Intrastat defaults',
        saved: 'Settings saved.',
        charts: {
          SKR03: 'Process based; revenue accounts in the 8000–8999 range.',
          SKR04: 'Balance sheet based; revenue accounts in the 4000–4999 range.',
        },
        fields: {
          consultantNumber: 'Consultant number',
          clientNumber: 'Client number',
          fiscalYearStart: 'Fiscal year start',
          accountNumberLength: 'Account number length',
          debtorAccountRangeStart: 'Debtor range start',
          dictationKey: 'Dictation key',
          reportingVatId: 'VAT ID of the declarant',
          federalState: 'Federal state',
          natureOfTransaction: 'Default nature of transaction',
          modeOfTransport: 'Default mode of transport',
        },
        mapping: {
          case: 'Tax case',
          account: 'Revenue account',
          buKey: 'Tax key',
          accountFor: 'Revenue account for {{case}}',
          buKeyFor: 'Tax key for {{case}}',
          automatic: 'Automatic',
        },
        revenueCases: {
          DOMESTIC_STANDARD: { label: 'Domestic 19 %', hint: 'Standard rate in Germany.' },
          DOMESTIC_REDUCED: { label: 'Domestic 7 %', hint: 'Reduced rate in Germany.' },
          DOMESTIC_EXEMPT: { label: 'Domestic exempt', hint: 'Zero-rated domestic turnover.' },
          INTRA_COMMUNITY: {
            label: 'EU zero-rated',
            hint: 'Intra-community supply, sec. 4 no. 1b UStG.',
          },
          EXPORT_NON_EU: { label: 'Non-EU export', hint: 'Export supply, sec. 4 no. 1a UStG.' },
          REVERSE_CHARGE: {
            label: 'Reverse charge',
            hint: 'Recipient owes the VAT, sec. 13b UStG.',
          },
        },
        debtors: {
          action: 'Assign debtor accounts',
          assigned_one: '{{count}} debtor account assigned.',
          assigned_other: '{{count}} debtor accounts assigned.',
        },
      },
      intrastat: {
        title: 'Intrastat declaration',
        subtitle: 'Dispatches to other EU member states per reference month.',
        periodSection: 'Reporting period',
        fields: {
          year: 'Reporting year',
          month: 'Reference month',
          direction: 'Flow',
        },
        directions: {
          DISPATCH: 'Dispatch',
          ARRIVAL: 'Arrival',
        },
        kpi: {
          value: 'Invoiced amount',
          weight: 'Net mass',
          positions: 'Declared items',
        },
        columns: {
          commodityCode: 'Commodity code (CN8)',
          destination: 'Destination',
          origin: 'Country of origin',
          nature: 'Nature of transaction',
          transport: 'Mode of transport',
          weight: 'Net mass',
          invoiced: 'Invoiced amount',
          statistical: 'Statistical value',
          partnerVatId: 'Partner VAT ID',
        },
        issueFields: {
          commodityCode: 'Commodity code missing or not 8 digits',
          countryOfOrigin: 'Country of origin missing',
          netWeight: 'Net weight missing',
          destinationCountry: 'Destination country missing',
        },
        readiness: {
          clean: 'All declarable items are complete.',
          blocked_one: '{{count}} product blocks the declaration.',
          blocked_other: '{{count}} products block the declaration.',
          openProduct: 'Open product',
        },
        states: {
          empty: 'No declarable dispatches for this reference month.',
        },
        export: {
          csv: 'Control list (.csv)',
          xml: 'INSTAT/XML for IDEV',
          success: 'Declaration file created and downloaded.',
        },
      },
    },
  },
} as const;
